export const content = {
    PRIVACY_POPUP: {
        id: 'kmx-privacy-popup',
        class: 'privacy-popup',
        CONTAINER: {
            class: 'privacy-popup-container'
        },
        HEADER: {
            class: 'privacy-popup-header',
            title: 'Your privacy'
        },
        MESSAGE: {
            class: 'privacy-popup-message',
            html: `By accessing this website, you acknowledge that CarMax and its third party business partners may use cookies, pixels, and similar technologies to collect information about you and your interactions with the website as described in our <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and you agree that your use of the website is subject to our <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Use</a>.`
        },
        CLOSE_BUTTON: {
            class: 'privacy-popup-close-button',
            iconClass: 'privacy-popup-close-icon',
            ariaLabel: 'Close privacy notice'
        }
    }
};
